import { catalog } from "../i18n.js";

/** The first-run tour's own screens (components/Tour.tsx); what is said in its practice chats is in tour-script.ts. */
export const TOUR = catalog(
  {
    skip: "Skip",
    skipTour: "Skip the tour",
    languageTitle: "Choose your language",
    languageAbout: "The app and this tour speak it. You can switch at any time from the top of the tour, and later in Settings. Your bots answer in whatever language you write to them.",
    languageNext: "Continue",
    languageSwitch: "Language",
    stageLanguage: "Languages",
    progress: (step: number, total: number) => `Step ${step} of ${total}`,
    back: "Back",
    tryIt: "Try it",
    next: "Next",
    finish: "Finish",
    stagePractice: (name: string) => `Practice chat with ${name}`,
    stageHire: "Your first bot",
    stageWelcome: "What ark-bot is",
    yourBot: (name: string) => `your ${name}`,

    crewSearching: "Searching the web…",
    crewWaiting: "Waiting for your approval",
    crewWatching: "Watching 3 pages",

    welcomeTitle: "Meet your bots",
    welcomeTeam: "ark-bot gives you a team of bots that work for you. Each one has a job, and you talk to it the way you’d text a person.",
    welcomeComputer: "Behind them is a small computer of your own, with a browser, a desktop, a terminal and files. You can watch a bot use it, and take over whenever you like.",
    welcomeWorkspace: "Behind them is a small workspace of your own, with a terminal, files and the web.",
    welcomePractice: "This short tour lets you try it with a practice bot. Nothing you do in it is sent anywhere.",

    chatTitle: "Send a message",
    chatAsk: (name: string) => `Tell ${name} what you want done, in your own words, or tap a suggestion.`,
    chatWorking: (name: string) => `${name} is on it. Bots reply in short messages, like texts, and the line under the chat says what it’s doing right now.`,
    chatNoWait: "You never have to wait: write again any time and your message reaches it straight away.",
    chatDone: "That’s a whole task: it said it was on it, did the work, and came back with the result. A real one can take minutes or hours, and you can close the app meanwhile.",
    chatHintSend: "Send a message to carry on.",
    chatHintWatch: "Watch it work, or write again.",

    checkTitle: "It checks with you first",
    checkDone: "You’re always the one who decides. In Settings, under Permissions, you can write down what to always allow and what to always bring to you.",
    checkAbout: "Reading and searching never need you. When a bot is about to act, say send something, run a command or press a button, the action is checked first, and anything that matters comes to you as a card like this one. Nothing happens until you answer.",
    checkHintAnswer: "Approve or decline the card.",
    checkHintComing: "Here it comes…",

    behindTitle: "See everything it did",
    behindSeen: "Every search, page and step is there, in order. Open one to see exactly what went in and what came back.",
    behindAbout: "Its messages are what it chose to tell you. The side pane holds the rest: its screen, its routines and skills, and the full conversation behind every reply.",
    behindHintShow: "Press Show beside Full conversation.",
    behindHintOpen: "Open the side pane with the button at the top right.",

    chiefDefault: "your Chief of Staff",
    chiefTitle: (who: string) => `Just tell ${who}`,
    chiefAbout: (who: string) => `You don’t have to know which bot does what. Tell ${who} what you need, in your own words: it hands each job to the bot whose job it is, and pulls you in only for decisions.`,
    chiefPracticeToo: "This one is practice too, so nothing is really sent.",
    chiefWatching: (manager: string) => `Watch it delegate. Nobody on a new team does this job yet, so it asks the ${manager} to make a bot for it. The card in the chat is one bot writing to another.`,
    chiefDone: (who: string) => `That’s how most days go: tell ${who} what you need, and it keeps the rest of the team busy. You can still write to any bot directly whenever you like.`,
    chiefHintExample: "Tap the example, or write your own.",
    chiefHintWatch: "Watch it hand the job over.",

    makeTitle: "Make your first bot",
    makeAbout: "Now a real one. Press + at the top of your list, give it a name and say what it does; it says hello on its own.",
    hireTitle: "Hire your first bot",
    hireAbout: (who: string) => `Now a real one. You don’t fill in a form: ${who}, already on your team, builds bots for you.`,
    hireHow: "Say what you need in a sentence. It asks about the details, shows you the bot it plans to make, and creates it only once you say yes.",
    onTeam: "Already on your team",

    hireChat: (name: string) => `Your first message to ${name}`,
    hireEmpty: "Your message shows here as you write it.",
    hireNext: "It asks about the details, then shows you the bot it plans to make and creates it once you say yes. The new bot shows up in your list and says hello.",
    hireQuestion: "What should your first bot do?",
    hirePlaceholder: "A bot that watches flight prices from Jakarta to Bali and tells me when they drop.",
    hireIdeas: "Or start from one of these",
    sending: "Sending…",
    sendTo: (name: string) => `Send to ${name}`,
    lookAround: "I’ll look around first",

    awaitingApproval: "Waiting for your approval",
    typing: "Typing…",
    working: "Working",
    practice: "Practice",
    showPane: "Show the side pane",
    paneTitleScreen: "The bot's screen, routines and full conversation",
    paneTitle: "The bot's routines and skills",
    suggestions: "Suggestions",

    details: "Details",
    fullConversation: "Full conversation",
    backToDetails: "Back to details",
    hideDetails: "Hide details",
    hidePane: "Hide this pane",
    screenCaption: (name: string) => `${name}’s screen: watch it work, and take over when you like`,
    practiceAbout: "A practice bot. A real bot’s description, what it reads about itself, shows here.",
    routines: "Routines",
    morningBrief: "Morning brief",
    morningBriefWhen: "at 08:00, Monday to Friday · an example",
    routinesAbout: "Work it does on a schedule, without being asked each time.",
    skills: "Skills",
    skillsAbout: "How you like things done, written down once: it reads them whenever they apply.",
    show: "Show",
    conversationAbout: "Everything the bot did between its messages: private notes, reasoning, tool calls and helpers.",
  },
  {
    skip: "Lewati",
    skipTour: "Lewati tur",
    languageTitle: "Pilih bahasamu",
    languageAbout: "Aplikasi dan tur ini akan memakai bahasa itu. Kamu bisa menggantinya kapan saja dari bagian atas tur, dan nanti di Pengaturan. Bot kamu membalas dalam bahasa apa pun yang kamu pakai.",
    languageNext: "Lanjut",
    languageSwitch: "Bahasa",
    stageLanguage: "Bahasa",
    progress: (step: number, total: number) => `Langkah ${step} dari ${total}`,
    back: "Kembali",
    tryIt: "Coba",
    next: "Lanjut",
    finish: "Selesai",
    stagePractice: (name: string) => `Chat latihan dengan ${name}`,
    stageHire: "Bot pertamamu",
    stageWelcome: "Apa itu ark-bot",
    yourBot: (name: string) => `${name} kamu`,

    crewSearching: "Mencari di web…",
    crewWaiting: "Menunggu persetujuanmu",
    crewWatching: "Memantau 3 halaman",

    welcomeTitle: "Kenalan dengan bot kamu",
    welcomeTeam: "ark-bot memberimu tim bot yang bekerja untukmu. Masing-masing punya tugas, dan kamu ngobrol dengannya seperti chat dengan orang.",
    welcomeComputer: "Di baliknya ada komputer kecil milikmu sendiri, lengkap dengan browser, desktop, terminal, dan file. Kamu bisa melihat bot memakainya, dan ambil alih kapan pun kamu mau.",
    welcomeWorkspace: "Di baliknya ada ruang kerja kecil milikmu sendiri, dengan terminal, file, dan web.",
    welcomePractice: "Tur singkat ini mengajakmu mencobanya dengan bot latihan. Apa pun yang kamu lakukan di sini tidak dikirim ke mana-mana.",

    chatTitle: "Kirim pesan",
    chatAsk: (name: string) => `Bilang ke ${name} apa yang mau dikerjakan, pakai kata-katamu sendiri, atau ketuk salah satu saran.`,
    chatWorking: (name: string) => `${name} sedang mengerjakannya. Bot membalas lewat pesan-pesan singkat, seperti chat biasa, dan baris di bawah judul chat menunjukkan apa yang sedang ia kerjakan.`,
    chatNoWait: "Kamu tidak perlu menunggu: tulis lagi kapan saja, dan pesanmu langsung sampai.",
    chatDone: "Itu satu tugas utuh: ia bilang siap, mengerjakannya, lalu kembali dengan hasilnya. Tugas sungguhan bisa makan waktu beberapa menit atau jam, dan selama itu kamu boleh menutup aplikasi.",
    chatHintSend: "Kirim pesan untuk lanjut.",
    chatHintWatch: "Lihat ia bekerja, atau tulis lagi.",

    checkTitle: "Ia tanya kamu dulu",
    checkDone: "Keputusan selalu di tanganmu. Di Pengaturan, bagian Izin, kamu bisa menulis apa yang selalu diizinkan dan apa yang selalu harus ditanyakan ke kamu.",
    checkAbout: "Membaca dan mencari tidak pernah butuh kamu. Saat bot mau bertindak, misalnya mengirim sesuatu, menjalankan perintah, atau menekan tombol, tindakannya diperiksa dulu, dan yang penting akan sampai ke kamu sebagai kartu seperti ini. Tidak ada yang terjadi sampai kamu menjawab.",
    checkHintAnswer: "Setujui atau tolak kartunya.",
    checkHintComing: "Sebentar lagi muncul…",

    behindTitle: "Lihat semua yang ia kerjakan",
    behindSeen: "Setiap pencarian, halaman, dan langkah ada di sana, berurutan. Buka salah satunya untuk melihat persis apa yang masuk dan apa yang keluar.",
    behindAbout: "Pesannya adalah apa yang ia pilih untuk diceritakan ke kamu. Sisanya ada di panel samping: layarnya, rutinitas dan keahliannya, serta percakapan lengkap di balik setiap balasan.",
    behindHintShow: "Tekan Tampilkan di samping Percakapan lengkap.",
    behindHintOpen: "Buka panel samping lewat tombol di kanan atas.",

    chiefDefault: "Chief of Staff kamu",
    chiefTitle: (who: string) => `Cukup bilang ke ${who}`,
    chiefAbout: (who: string) => `Kamu tidak perlu tahu bot mana mengerjakan apa. Bilang saja ke ${who} apa yang kamu butuhkan, pakai kata-katamu sendiri: ia menyerahkan tiap tugas ke bot yang tepat, dan hanya melibatkanmu untuk keputusan.`,
    chiefPracticeToo: "Yang ini juga latihan, jadi tidak ada yang benar-benar dikirim.",
    chiefWatching: (manager: string) => `Lihat ia membagi tugas. Di tim yang baru, belum ada yang mengerjakan tugas ini, jadi ia minta ${manager} membuatkan bot untuk itu. Kartu di chat itu adalah pesan dari satu bot ke bot lain.`,
    chiefDone: (who: string) => `Begitulah hari-hari biasanya: bilang ke ${who} apa yang kamu butuhkan, dan ia yang membagi kerja ke tim lainnya. Kamu tetap bisa chat langsung ke bot mana pun kapan saja.`,
    chiefHintExample: "Ketuk contohnya, atau tulis sendiri.",
    chiefHintWatch: "Lihat ia menyerahkan tugasnya.",

    makeTitle: "Buat bot pertamamu",
    makeAbout: "Sekarang yang sungguhan. Tekan + di atas daftarmu, beri nama, dan tulis tugasnya; bot itu akan menyapa sendiri.",
    hireTitle: "Rekrut bot pertamamu",
    hireAbout: (who: string) => `Sekarang yang sungguhan. Kamu tidak perlu mengisi formulir: ${who}, yang sudah ada di timmu, akan membuatkan bot untukmu.`,
    hireHow: "Tulis kebutuhanmu dalam satu kalimat. Ia akan menanyakan detailnya, menunjukkan bot yang mau dibuat, dan baru membuatnya setelah kamu setuju.",
    onTeam: "Sudah ada di timmu",

    hireChat: (name: string) => `Pesan pertamamu ke ${name}`,
    hireEmpty: "Pesanmu muncul di sini saat kamu menulisnya.",
    hireNext: "Ia akan menanyakan detailnya, lalu menunjukkan bot yang mau dibuat, dan membuatnya setelah kamu setuju. Bot barunya muncul di daftarmu dan menyapa.",
    hireQuestion: "Apa tugas bot pertamamu?",
    hirePlaceholder: "Bot yang memantau harga tiket pesawat Jakarta–Bali dan kasih tahu aku kalau harganya turun.",
    hireIdeas: "Atau mulai dari salah satu ini",
    sending: "Mengirim…",
    sendTo: (name: string) => `Kirim ke ${name}`,
    lookAround: "Aku lihat-lihat dulu",

    awaitingApproval: "Menunggu persetujuanmu",
    typing: "Mengetik…",
    working: "Sedang bekerja",
    practice: "Latihan",
    showPane: "Tampilkan panel samping",
    paneTitleScreen: "Layar, rutinitas, dan percakapan lengkap bot ini",
    paneTitle: "Rutinitas dan keahlian bot ini",
    suggestions: "Saran",

    details: "Detail",
    fullConversation: "Percakapan lengkap",
    backToDetails: "Kembali ke detail",
    hideDetails: "Sembunyikan detail",
    hidePane: "Sembunyikan panel ini",
    screenCaption: (name: string) => `Layar ${name}: lihat ia bekerja, dan ambil alih kapan pun kamu mau`,
    practiceAbout: "Bot latihan. Deskripsi bot sungguhan, yang ia baca tentang dirinya sendiri, muncul di sini.",
    routines: "Rutinitas",
    morningBrief: "Ringkasan pagi",
    morningBriefWhen: "pukul 08.00, Senin sampai Jumat · contoh",
    routinesAbout: "Pekerjaan yang ia lakukan sesuai jadwal, tanpa perlu diminta setiap kali.",
    skills: "Keahlian",
    skillsAbout: "Cara yang kamu suka, ditulis sekali: ia membacanya setiap kali relevan.",
    show: "Tampilkan",
    conversationAbout: "Semua yang dikerjakan bot di antara pesan-pesannya: catatan pribadi, penalaran, pemanggilan tool, dan bot pembantu.",
  },
);
